module.exports = __webpack_public_path__ + "img/picture.22f474a8.png";